import React from "react";

import { Grid, Paper } from "@material-ui/core";
import { DckSelectors, DckActionCreators } from "dck-redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";

import { breadcrumbsFor, generalFormFor } from "srx-shared";
import { ActionsSpinner, FormButton } from "srx-shared/mui";

import { FreezeVariablesItem } from "@items/FreezeVariables";
import { pages } from "@routes/pages";

import DistributorName from "../DistributorName";

const FreezeVariablesForm = generalFormFor(FreezeVariablesItem);
const Breadcrumbs = breadcrumbsFor();

class FreezeVariables extends React.PureComponent {
  static propTypes = {
    freezeVariables: PropTypes.object,
    updating: PropTypes.bool,
    updateFreezeVariables: PropTypes.func,
    loadFreezeVariables: PropTypes.func,
    match: PropTypes.object
  };

  componentDidMount() {
    const {
      loadFreezeVariables,
      match: { params }
    } = this.props;
    loadFreezeVariables(params.id);
  }

  handleSave = data => {
    const {
      updateFreezeVariables,
      match: { params }
    } = this.props;
    updateFreezeVariables(params.id, data);
  };

  breadcrumbsList = () => [
    { title: pages.distributors.title, to: pages.distributors.path },
    { title: <DistributorName /> },
    { title: "Freeze" }
  ];

  renderActions = (form, formikProps) => {
    const { updating } = this.props;
    const { dirty } = formikProps;
    const disabled = !dirty || updating;
    return (
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "flex-end",
          marginRight: 12
        }}
      >
        <ActionsSpinner processing={updating} />
        <FormButton variant="reset" disabled={disabled} />
        <FormButton variant="save" disabled={disabled} />
      </div>
    );
  };

  render() {
    const { freezeVariables, updating } = this.props;
    return (
      <Grid container justify="center">
        <Breadcrumbs renderList={this.breadcrumbsList} />
        <Paper style={{ padding: 24, maxWidth: 800 }}>
          <FreezeVariablesForm
            renderActions={this.renderActions}
            initialData={freezeVariables}
            onSubmit={this.handleSave}
            processing={updating}
          />
        </Paper>
      </Grid>
    );
  }
}

const process = `${FreezeVariablesItem.type.toUpperCase()}_UPDATE`;

const mapStateToProps = state => ({
  freezeVariables: DckSelectors.getItemData(
    state,
    FreezeVariablesItem.type,
    "values"
  ),
  updating: DckSelectors.selectProcessRunning(state, process)
});

const mapDispatchToProps = {
  updateFreezeVariables: (id, data) =>
    DckActionCreators.itemSave(FreezeVariablesItem.type, id, data),
  loadFreezeVariables: id =>
    DckActionCreators.itemsLoad(FreezeVariablesItem.type, { id })
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(FreezeVariables);
